import { useQueryClient } from "@tanstack/react-query";
import { Input, Spin } from "antd";
import { Send } from "lucide-react";
import { FC, useState } from "react";
import { useNotification } from "~/hooks";
import { TASK_KEYS, useCreateNote } from "~/services/task";
import { Task } from "~/types/task";

type Props = {
  task: Task;
};

export const AddNote: FC<Props> = ({ task }) => {
  const [note, setNote] = useState("");

  const qc = useQueryClient();
  const { success, error } = useNotification();
  const { mutate, isPending } = useCreateNote();

  const handleAddNote = () => {
    if (!task || !note) return;

    mutate(
      {
        content: note,
        taskId: task.id,
      },
      {
        onSuccess: () => {
          qc.invalidateQueries({
            queryKey: TASK_KEYS.GET_TASKS({}),
          });
          success({
            message: "Create note successfully",
          });
          setNote("");
        },
        onError: (err) => {
          error({
            message: "Can not create note!",
            description: err.message,
          });
        },
      }
    );
  };
  return (
    <div className="mt-3">
      <Spin spinning={isPending}>
        <div className="relative">
          <Input
            disabled={isPending}
            type="text"
            className="w-full border rounded-lg p-2"
            placeholder="Add a note..."
            value={note}
            onChange={(e) => setNote(e.target.value)}
            onKeyDown={(e) =>
              e.key === "Enter" && note.trim() ? handleAddNote() : {}
            }
          />
          <Send
            onClick={handleAddNote}
            className="cursor-pointer text-blue-500 absolute top-1/2 right-2 -translate-y-1/2"
          />
        </div>
      </Spin>
    </div>
  );
};
